import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { ProductRightComponent } from '../../../app/content/modules/page/components/product/components/product-right/product-right.component';
import { withCommonDecorators } from '../../_utils/story-helpers';
import {
  createDamilanoBarberaProduct,
  createDiscountedProduct,
  createQuantityPricedProduct,
  createOutOfStockProduct,
  createProductWithRatings,
  createLastBottlesProduct,
} from '../../_mocks/wine-product.mock';

const meta: Meta<ProductRightComponent> = {
  title: 'Organisms/Product/Product Right',
  component: ProductRightComponent,
  decorators: [...withCommonDecorators()],
  parameters: {
    layout: 'padded',
  },
};

export default meta;
type Story = StoryObj<ProductRightComponent>;

export const Default: Story = {
  args: {
    product: createDamilanoBarberaProduct(),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/på lager/i)).toBeInTheDocument();
  },
};

export const WithQuantityPricing: Story = {
  args: {
    product: createQuantityPricedProduct(),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/på lager/i)).toBeInTheDocument();
  },
};

export const Discounted: Story = {
  args: {
    product: createDiscountedProduct(),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/på lager/i)).toBeInTheDocument();
  },
};

export const WithRatings: Story = {
  args: {
    product: createProductWithRatings(),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/på lager/i)).toBeInTheDocument();
  },
};

export const OutOfStock: Story = {
  args: {
    product: createOutOfStockProduct(),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/udsolgt/i)).toBeInTheDocument();
  },
};

export const LimitedStock: Story = {
  args: {
    product: createDamilanoBarberaProduct({ stock: 3 }),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/på lager/i)).toBeInTheDocument();
  },
};

export const LastBottles: Story = {
  args: {
    product: createLastBottlesProduct(),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/på lager/i)).toBeInTheDocument();
  },
};
